const PublisherModuleDetail = {
    title: 'Anchor Chat',
    nav: [
        {
            name: 'Search',
            url: 'search',
            groupsAllowed: [],
        },
    ],
    loadModule: () => import('./bigfishgames-anchor-chat-portal-module.module-0cf7e0e2.mjs').then((m) => m.PortalModule),
};

/*
 * Public API Surface of hello-module
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PublisherModuleDetail };
